
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "129px",
    "height": "150px",
    "viewBox": "0 0 129 150",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "自动驾驶车辆"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "Icon",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "画板",
            "transform": "translate(-19.000000, -1.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "自动驾驶车辆",
                "transform": "translate(19.383852, 2.000000)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "车",
                    "transform": "translate(18.385419, 24.458599)"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M13.0258182,5.0955414 L76.4547509,5.0955414 C78.1009588,5.0955414 79.4396535,6.42211474 79.4546268,8.0682546 C79.6364179,28.0541282 79.8182089,48.0400017 80,68.0258753 C79.8268467,77.6594251 79.6536933,87.2929749 79.48054,96.9265247 C79.4511422,98.5620982 78.1168621,99.8726115 76.4810245,99.8726115 L12.9992175,99.8726115 C11.3636446,99.8726115 10.0294783,98.5625072 9.9997143,96.9272051 L9.47368421,68.0258753 L9.47368421,68.0258753 L10.0259454,8.06791015 C10.0411064,6.42190629 11.3797445,5.0955414 13.0258182,5.0955414 Z",
                        "id": "矩形",
                        "fill": "#013A07"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#013A07",
                        "x": "68.4210526",
                        "y": "2.03821656",
                        "width": "6.31578947",
                        "height": "4.07643312"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#013A07",
                        "x": "69.4736842",
                        "y": "0",
                        "width": "4.21052632",
                        "height": "3.05732484"
                      }
                    },
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "左后视镜",
                        "transform": "translate(0.000000, 24.458599)",
                        "fill": "#013A07"
                      },
                      "children": [
                        {
                          "tag": "rect",
                          "attrsMap": {
                            "id": "矩形",
                            "x": "6.47773279",
                            "y": "4.07643312",
                            "width": "4.048583",
                            "height": "3.05732484"
                          }
                        },
                        {
                          "tag": "rect",
                          "attrsMap": {
                            "id": "矩形",
                            "x": "0",
                            "y": "0",
                            "width": "8.09716599",
                            "height": "19.3630573"
                          }
                        }
                      ]
                    },
                    {
                      "tag": "g",
                      "attrsMap": {
                        "id": "右后视镜",
                        "transform": "translate(84.210526, 34.140127) scale(-1, 1) translate(-84.210526, -34.140127) translate(78.947368, 24.458599)",
                        "fill": "#013A07"
                      },
                      "children": [
                        {
                          "tag": "rect",
                          "attrsMap": {
                            "id": "矩形",
                            "x": "6.47773279",
                            "y": "4.07643312",
                            "width": "4.048583",
                            "height": "3.05732484"
                          }
                        },
                        {
                          "tag": "rect",
                          "attrsMap": {
                            "id": "矩形",
                            "x": "0",
                            "y": "0",
                            "width": "8.09716599",
                            "height": "19.3630573"
                          }
                        }
                      ]
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#FFFFFF",
                        "x": "14.7368421",
                        "y": "18.343949",
                        "width": "61.0526316",
                        "height": "40.7643312"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#FFFFFF",
                        "x": "32.6315789",
                        "y": "8.15286624",
                        "width": "25.2631579",
                        "height": "8.15286624"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#FFFFFF",
                        "x": "14.7368421",
                        "y": "81.5286624",
                        "width": "13.6842105",
                        "height": "8.15286624"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形备份",
                        "fill": "#FFFFFF",
                        "x": "61.0526316",
                        "y": "81.5286624",
                        "width": "13.6842105",
                        "height": "8.15286624"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#013A07",
                        "x": "13.6842105",
                        "y": "98.8535032",
                        "width": "9.47368421",
                        "height": "9.17197452"
                      }
                    },
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形备份-2",
                        "fill": "#013A07",
                        "x": "66.3157895",
                        "y": "98.8535032",
                        "width": "9.47368421",
                        "height": "9.17197452"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "上方信号",
                    "transform": "translate(40.701208, 0.000000)",
                    "stroke": "#013A07",
                    "stroke-linecap": "square",
                    "stroke-width": "2"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M12.9149396,24 C16.2394059,22 19.7394059,21 23.4149396,21 C27.0904733,21 30.5904733,22 33.9149396,24",
                        "id": "直线"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M6.91493959,16 C12.0293982,12.6666667 17.3870341,11 22.9878473,11 C28.5886605,11 33.8976913,12.6666667 38.9149396,16",
                        "id": "直线备份"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M0.914939592,5 C7.92875571,1.66666667 15.2862228,0 22.987341,0 C30.6884591,0 37.9976587,1.66666667 44.9149396,5",
                        "id": "直线备份-2"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "前雷达信号",
                    "transform": "translate(56.332787, 127.407643)",
                    "fill": "#013A07"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.78336064,20.5923567 C13.477781,20.5923567 17.2833606,14.5923567 17.2833606,14.5923567 C17.2833606,14.5923567 12.1035835,17.1637853 8.78336064,17.1637853 C5.46313777,17.1637853 0.283360644,14.5923567 0.283360644,14.5923567 C0.283360644,14.5923567 4.08894027,20.5923567 8.78336064,20.5923567 Z",
                        "id": "椭圆形"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.28336064,15.5923567 C12.1493539,15.5923567 15.2833606,11.5923567 15.2833606,11.5923567 C15.2833606,11.5923567 11.0176618,13.3066424 8.28336064,13.3066424 C5.54905945,13.3066424 1.28336064,11.5923567 1.28336064,11.5923567 C1.28336064,11.5923567 4.4173674,15.5923567 8.28336064,15.5923567 Z",
                        "id": "椭圆形备份"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.28336064,11.5923567 C11.5970691,11.5923567 14.2833606,8.59235669 14.2833606,8.59235669 C14.2833606,8.59235669 10.6270474,9.87807097 8.28336064,9.87807097 C5.93967391,9.87807097 2.28336064,8.59235669 2.28336064,8.59235669 C2.28336064,8.59235669 4.96965215,11.5923567 8.28336064,11.5923567 Z",
                        "id": "椭圆形备份-2"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.78336064,8.59235669 C11.268642,8.59235669 13.2833606,5.59235669 13.2833606,5.59235669 C13.2833606,5.59235669 10.5411257,6.87807097 8.78336064,6.87807097 C7.02559559,6.87807097 4.28336064,5.59235669 4.28336064,5.59235669 C4.28336064,5.59235669 6.29807927,8.59235669 8.78336064,8.59235669 Z",
                        "id": "椭圆形备份-3"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.78336064,4.59235669 C10.7163573,4.59235669 12.2833606,2.59235669 12.2833606,2.59235669 C12.2833606,2.59235669 10.1505112,3.44949955 8.78336064,3.44949955 C7.41621005,3.44949955 5.28336064,2.59235669 5.28336064,2.59235669 C5.28336064,2.59235669 6.85036402,4.59235669 8.78336064,4.59235669 Z",
                        "id": "椭圆形备份-4"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M8.28336064,1.59235669 C9.38793014,1.59235669 10.2833606,0.592356688 10.2833606,0.592356688 C10.2833606,0.592356688 9.06458956,1.02092812 8.28336064,1.02092812 C7.50213173,1.02092812 6.28336064,0.592356688 6.28336064,0.592356688 C6.28336064,0.592356688 7.17879114,1.59235669 8.28336064,1.59235669 Z",
                        "id": "椭圆形备份-5"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "右雷达信号",
                    "transform": "translate(112.616148, 123.500000) rotate(-52.000000) translate(-112.616148, -123.500000) translate(102.616148, 112.000000)",
                    "fill": "#013A07"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M9.66445994,22.3480895 C14.8966313,22.3480895 19.1381441,15.3480895 19.1381441,15.3480895 C19.1381441,15.3480895 13.3650179,18.3480895 9.66445994,18.3480895 C5.96390193,18.3480895 0.190775728,15.3480895 0.190775728,15.3480895 C0.190775728,15.3480895 4.43228862,22.3480895 9.66445994,22.3480895 Z",
                        "id": "椭圆形"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M9.56065611,16.3490621 C14.2114751,16.3490621 17.9817087,11.3490621 17.9817087,11.3490621 C17.9817087,11.3490621 12.850041,13.4919192 9.56065611,13.4919192 C6.27127121,13.4919192 1.13960347,11.3490621 1.13960347,11.3490621 C1.13960347,11.3490621 4.90983716,16.3490621 9.56065611,16.3490621 Z",
                        "id": "椭圆形备份"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.0142068,12.3398815 C13.7929972,12.3398815 16.8563121,8.33988152 16.8563121,8.33988152 C16.8563121,8.33988152 12.6868321,10.0541672 10.0142068,10.0541672 C7.34158161,10.0541672 3.17210158,8.33988152 3.17210158,8.33988152 C3.17210158,8.33988152 6.23541645,12.3398815 10.0142068,12.3398815 Z",
                        "id": "椭圆形备份-2"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M9.63827257,8.94636242 C12.5450344,8.94636242 14.9014305,5.94636242 14.9014305,5.94636242 C14.9014305,5.94636242 11.6941381,7.23207671 9.63827257,7.23207671 C7.58240701,7.23207671 4.37511467,5.94636242 4.37511467,5.94636242 C4.37511467,5.94636242 6.73151073,8.94636242 9.63827257,8.94636242 Z",
                        "id": "椭圆形备份-3"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M9.44375859,4.1491711 C11.4784919,4.1491711 13.1279691,2.1491711 13.1279691,2.1491711 C13.1279691,2.1491711 10.8828645,3.00631396 9.44375859,3.00631396 C8.0046527,3.00631396 5.75954806,2.1491711 5.75954806,2.1491711 C5.75954806,2.1491711 7.4090253,4.1491711 9.44375859,4.1491711 Z",
                        "id": "椭圆形备份-4"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M9.39185667,1.14965738 C10.8452376,1.14965738 12.0234356,0.149657378 12.0234356,0.149657378 C12.0234356,0.149657378 10.4197895,0.578228807 9.39185667,0.578228807 C8.36392389,0.578228807 6.76027773,0.149657378 6.76027773,0.149657378 C6.76027773,0.149657378 7.93847575,1.14965738 9.39185667,1.14965738 Z",
                        "id": "椭圆形备份-5"
                      }
                    }
                  ]
                },
                {
                  "tag": "g",
                  "attrsMap": {
                    "id": "左雷达信号",
                    "transform": "translate(15.689479, 124.291230) scale(-1, 1) rotate(-52.000000) translate(-15.689479, -124.291230) translate(5.689479, 112.791230)",
                    "fill": "#013A07"
                  },
                  "children": [
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.3363854,22.5788635 C15.5830906,22.5788635 19.8363854,16.5788635 19.8363854,16.5788635 C19.8363854,16.5788635 14.0472228,19.1502921 10.3363854,19.1502921 C6.6255481,19.1502921 0.836385431,16.5788635 0.836385431,16.5788635 C0.836385431,16.5788635 5.08968031,22.5788635 10.3363854,22.5788635 Z",
                        "id": "椭圆形"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.5456025,16.9738415 C14.9638805,16.9738415 18.5456025,12.9738415 18.5456025,12.9738415 C18.5456025,12.9738415 13.6705182,14.6881272 10.5456025,14.6881272 C7.42068688,14.6881272 2.54560253,12.9738415 2.54560253,12.9738415 C2.54560253,12.9738415 6.12732453,16.9738415 10.5456025,16.9738415 Z",
                        "id": "椭圆形备份"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M11.0626504,12.7628248 C14.9286436,12.7628248 18.0626504,8.76282478 18.0626504,8.76282478 C18.0626504,8.76282478 13.7969516,10.4771105 11.0626504,10.4771105 C8.32834917,10.4771105 4.06265036,8.76282478 4.06265036,8.76282478 C4.06265036,8.76282478 7.19665711,12.7628248 11.0626504,12.7628248 Z",
                        "id": "椭圆形备份-2"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.7055128,9.36930569 C13.7430789,9.36930569 16.2055128,6.36930569 16.2055128,6.36930569 C16.2055128,6.36930569 12.8538923,7.65501997 10.7055128,7.65501997 C8.55713329,7.65501997 5.2055128,6.36930569 5.2055128,6.36930569 C5.2055128,6.36930569 7.66794668,9.36930569 10.7055128,9.36930569 Z",
                        "id": "椭圆形备份-3"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.3483752,5.97578659 C12.5575142,5.97578659 14.3483752,3.97578659 14.3483752,3.97578659 C14.3483752,3.97578659 11.9108331,4.83292945 10.3483752,4.83292945 C8.78591742,4.83292945 6.34837525,3.97578659 6.34837525,3.97578659 C6.34837525,3.97578659 8.13923625,5.97578659 10.3483752,5.97578659 Z",
                        "id": "椭圆形备份-4"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M10.7792484,1.96660602 C12.1599603,1.96660602 13.2792484,0.966606018 13.2792484,0.966606018 C13.2792484,0.966606018 11.7557846,1.39517745 10.7792484,1.39517745 C9.8027123,1.39517745 8.27924844,0.966606018 8.27924844,0.966606018 C8.27924844,0.966606018 9.39853657,1.96660602 10.7792484,1.96660602 Z",
                        "id": "椭圆形备份-5"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  